import React, { useState, useEffect } from "react";
import api from "../../services/api";
import CuttingSheetsPanel from "./CuttingSheetsPanel";

export default function CuttingPage() {

  const [activeSheetsTab, setActiveSheetsTab] = useState("current"); // current | completed

  return (
    <div className="container-fluid py-4">
        <div className="d-flex justify-content-between">
        <h3 className="mb-3">Листы на резку</h3>
        </div>

        <CuttingSheetsPanel
        activeTab={activeSheetsTab}
        setActiveTab={setActiveSheetsTab}
        />
    </div>
  );
}
